export const heroAbout = () => {
  if (document.querySelector('.hero-about')) {
    window.lenis = lenis;
    const heroAboutSection = document.querySelector('.hero-about');
    document.querySelector('.hero-about .button')?.addEventListener('click', () => {
      // Scroll to the start of the next section, not a full viewport down.
      const target = heroAboutSection.nextElementSibling
        || (window.scrollY + heroAboutSection.getBoundingClientRect().bottom);
      lenis.scrollTo(target, {
        offset: -100, // clear the sticky header
        duration: 1,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
    });
  }
}